import { render, staticRenderFns } from "./rechargeList.vue?vue&type=template&id=2fb4c8c8"
import script from "./rechargeList.vue?vue&type=script&lang=js"
export * from "./rechargeList.vue?vue&type=script&lang=js"
import style0 from "./rechargeList.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports